export enum CallDispositionAction {
  NONE = "NONE",
  DO_NOT_CALL_NUMBER = "DO_NOT_CALL_NUMBER",
  WRONG_NUMBER = "WRONG_NUMBER",
  SCHEDULE_CALLBACK = "SCHEDULE_CALLBACK",
  REMOVE_FROM_CAMPAIGN = "REMOVE_FROM_CAMPAIGN",
}
